import React, { Component } from 'react';
import './cigerate.css';
import Navbar from '../layouts/navbar';
import {HashLink} from 'react-router-hash-link';

class Cocaine extends Component {
    componentDidMount(){
        window.scrollTo(0,0);
    }
    render() {
        return (
        <div>
            <Navbar head="Cocaine"/>
            <div className="container" style={{marginTop:"60px"}}>
            <HashLink to='/faq#cocaine'>
                <button id="myBtn" title="FAQ">
                <i class="fas fa-info-circle faqicon"></i> 
                    <p>  FAQ</p>
                </button>
                </HashLink>
                
                <div className="row justify-content-center">
                        <div className="col-12 text-center ">
                        <img className="img-fluid" src="/assests/images/educationCocaine.png" alt="cocaine">
                        </img>
                        
                        </div>
                    </div>

                <div className="content">
                    <h2>
                    What are Stimulants? (includes cocaine, meth, amphetamines, mdma)
                    </h2>
                    <p>
                    Some substances, called stimulants, work on individuals by <b>increasing alertness and energy levels of users</b>. They come in tablets, capsules, and even in liquid form.
                    Common stimulants include MDMA, cocaine, methamphetamine, amphetamines or prescription drugs like Addwize and Inspiral.

                    </p>
                    <h2>Cocaine</h2>
                    <p> Cocaine is a <b>highly addictive stimulant</b>, made from the coca plant 
                        in South America, which looks like a <b>fine, white colored powder</b>. It is often mixed 
                        with similar-looking substances like cornstarch, talcum powder, or flour to increase profits. It may also be mixed with other stimulants or opioids which makes
                         it <b>extremely risky and highly addictive.</b> </p>

                    <p>Street names of cocaine are crack, powder, chitta, coke, and snow.</p>
                    <p>The substance is usually snorted, but can also be consumed through injecting, rubbing into gums, or smoking. A combination of cocaine and heroin, known as speedball, can also be injected. Cocaine can be processed into <b>rock crystals and smoked, this form is known as crack</b>
                    . Some people also smoke crack by sprinkling it on marijuana or tobacco, and using it as a cigarette.</p>

                    <p>
                    People who use cocaine often <b>take it in binges</b> (repeatedly within a short time) and at higher doses which makes <b>cocaine abuse and dependence</b> more common. Since the drug floods the brain with dopamine and does not allow it from being recycled, it reinforces drug-taking behaviours. As such, the brain adapts to this excess of dopamine and become less sensitive to it which leads to tolerance towards cocaine and to get relief from withdrawal (more needs to be consumed for the same “high”).
                    </p>
                    


                    <h4>Short term effects include-</h4>
                        <ul>
                            <li><p>Hypersensitivity to light, sound, touch</p></li>
                            <li><p>Extreme energy</p></li>
                            <li><p>Irritability</p></li>
                            <li><p>Paranoia</p></li>
                            <li><p>Unpredictable, violent behaviour</p></li>
                            <li><p>Constricted blood vessels</p></li>
                            <li><p>Raised body temperature, BP</p></li>
                            <li><p>Nausea, dilated pupils</p></li>
                            <li><p>Irregular heartbeat</p></li>
                            <li><p>Tremors, muscle twitches</p></li>
                            <li><p>Restlessness</p></li>
                        </ul>

                    <h4>
                    Long term effects include-
                    </h4>
                    <ul>
                        <li><p>Loss of smell, <b>nosebleeds, runny nose</b>, problems in swallowing (in case of snorting)</p></li>
                        <li><p>Cough, asthma, <b>respiratory distress</b> (in case of smoking)</p></li>
                        <li><p><b>Severe bowel decay</b> from reduced blood flow (in case of consuming by mouth)</p></li>
                        <li><p><b>Higher risk of HIV, hepatitis C</b>, other bloodborne diseases, skin or tissue infection, scarring or collapsed veins (in case of injecting)</p></li>
                        <li><p><b>Malnourishment</b>, loss in weight</p></li>
                        <li><p><b>Movement disorders</b> like Parkinson’s</p></li>
                        <li><p>Severe <b>paranoia</b>, auditory <b>hallucinations</b> (hearing noises that aren’t real)</p></li>
                    </ul>
                </div>
            </div>
        </div>
        )
    }
}

export default Cocaine;